var map = {
	"./boy.jpg": 6488,
	"./default.png": 8736,
	"./girl.jpg": 9508,
	"./man.jpg": 5724,
	"./man2.jpg": 1280,
	"./man3.jpg": 7740,
	"./man4.jpg": 6452,
	"./woman.jpg": 4412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 436;